import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useThemesRecommendationDialogStyles = makeStyles({
  finalUrlSection: {
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    '> span': { whiteSpace: 'inherit' },
  },
  description: {
    marginTop: tokens.spacingVerticalM,
  },
  resultsDescription: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalS,
    ...shorthands.gap(tokens.spacingHorizontalSNudge),
  },
});
